import React from 'react';
import { useTranslation } from 'react-i18next';
import { APPROVED_TEMPLATES, WEEK_DAYS } from '../../lib/data/verticalPresets';

const money = (x) =>
  typeof x === 'number' && !isNaN(x) ? `$${x.toLocaleString('es-AR')}` : '—';

// Paso 5 — Review + estado templates + submit.
function StepReview({ state, preset, submitting, submitError, onSubmit }) {
  const { t } = useTranslation();
  const { org, resources, coverages, hours, vertical } = state;

  const dayLabel = (key) => t(`setupWizard.days.${key}`, key);
  const activeDays = WEEK_DAYS.filter((d) => hours?.days?.includes(d.value));
  const daysSummary = activeDays.length
    ? `${dayLabel(activeDays[0].labelKey)}–${dayLabel(activeDays[activeDays.length - 1].labelKey)}`
    : '—';

  const activeCoverages = coverages.filter(
    (c) => c.priceArs !== null && c.priceArs !== '' && !isNaN(Number(c.priceArs))
  );

  const templates = preset?.templatesRequired || [];

  return (
    <div className="sw-step">
      <h2 className="sw-step-title">
        {t('setupWizard.step5.title', 'Revisá el setup antes de crear')}
      </h2>

      <dl className="sw-review">
        <div className="sw-review-row">
          <dt>{t('setupWizard.step5.business', 'Negocio')}</dt>
          <dd>
            {org.name}{' '}
            <span className="sw-review-muted">
              ({t(`setupWizard.vertical.${vertical}`, preset?.label || vertical)})
            </span>
          </dd>
        </div>
        <div className="sw-review-row">
          <dt>{t('setupWizard.step1.phone', 'WhatsApp Business')}</dt>
          <dd>{org.phone}</dd>
        </div>
        <div className="sw-review-row">
          <dt>{t('setupWizard.step1.email', 'Email del dueño')}</dt>
          <dd>{org.email}</dd>
        </div>
        <div className="sw-review-row">
          <dt>
            {t(`setupWizard.resourceTypePlural.${preset?.resourceType}`, 'Recursos')} (
            {resources.length})
          </dt>
          <dd>{resources.map((r) => r.name).join(', ')}</dd>
        </div>
        <div className="sw-review-row">
          <dt>{t('setupWizard.step5.pricing', 'Tarifas')}</dt>
          <dd>
            {activeCoverages.map((c) => `${c.name} ${money(Number(c.priceArs))}`).join(' · ')}
          </dd>
        </div>
        <div className="sw-review-row">
          <dt>{t('setupWizard.step5.hours', 'Horarios')}</dt>
          <dd>
            {hours?.customPerDay
              ? t('setupWizard.step5.customHours', 'Personalizado por día')
              : `${daysSummary} ${hours?.openTime}–${hours?.closeTime}`}
          </dd>
        </div>
      </dl>

      <div className="sw-templates">
        <h3 className="sw-label">{t('setupWizard.step5.templates', 'Templates WhatsApp')}</h3>
        <ul className="sw-template-list">
          {templates.map((tpl) => {
            const approved = APPROVED_TEMPLATES.has(tpl);
            return (
              <li key={tpl} className={`sw-template ${approved ? 'approved' : 'pending'}`}>
                <span className="sw-template-status" aria-hidden="true">
                  {approved ? '✅' : '⚠️'}
                </span>
                <code>{tpl}</code>
                {!approved && (
                  <span className="sw-template-note">
                    {t('setupWizard.step5.pendingMeta', '(pendiente Meta)')}
                  </span>
                )}
              </li>
            );
          })}
        </ul>
      </div>

      {submitError && (
        <div className="sw-result sw-result-error" role="alert">
          <span className="material-icons">error_outline</span>
          <div>
            <strong>{t('setupWizard.error.title', 'No se pudo crear el negocio')}</strong>
            <p>
              {submitError.step
                ? t('setupWizard.error.atStep', {
                    step: submitError.step,
                    defaultValue: 'Falló en el paso: {{step}}. No se creó nada, podés reintentar.',
                  })
                : t('setupWizard.error.generic', 'Ocurrió un error. Podés reintentar.')}
            </p>
          </div>
        </div>
      )}

      <button
        type="button"
        className="btn btn-primary btn-block sw-submit"
        onClick={onSubmit}
        disabled={submitting}
      >
        {submitting
          ? t('setupWizard.step5.submitting', 'Creando negocio…')
          : t('setupWizard.step5.submit', 'Crear negocio ✓')}
      </button>
    </div>
  );
}

export default StepReview;
